import React, { useContext } from 'react';
import mockup from '../../assets/mockup13.png'; 
import { FaArrowRight } from 'react-icons/fa';


import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

import './PhoneSection.css';


const PhoneSection = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  

  const handleGetStartedClick = () => {
    if (user) {
      navigate('/purchase');
    } else {
      navigate('/signup');
    }
  };

  return (
      <div className="phone-section">
             <div className="content">
               <div className="text-block">
                 
                 <h1
                  data-aos="fade-right"
                   data-aos-duration="600"
                 >
                   Fully Automated Tool for Recovering Forgotten Crypto Wallets
                 </h1>
     
                 <h2
                  data-aos="fade-right"
                   data-aos-duration="650"
                  data-aos-delay="50"
                   >
                   Our software is powered by AI-enhanced cryptographic intelligence,
                   exploring real-time phrase discovery using advanced hashing models 
                   like SHA-256 and BIP39 mnemonic decoding.
                 </h2>
                 
     
                 <div
                  data-aos="fade-up"
                   data-aos-duration="600"
                  data-aos-delay="100"
                 >
                  <button className="started-button" onClick={handleGetStartedClick}>
                   Start Finding NOW <FaArrowRight className="button-arrow" />
                 </button>
                 </div>
               </div>
     
               <div
                 className="image-block"
                 data-aos="fade-up"
                 data-aos-duration="650"
               >
                 <img draggable="false" src={mockup} alt="LunaSearch" />
               </div>
             </div>
           </div>
  );
};

export default PhoneSection;
